// src/components/AboutLayout.jsx
import { useLocation } from 'react-router-dom';
import NavTabs from './NavTabs.jsx';

export default function AboutLayout({ data, heroBg, tabs, children }) {
  const { pathname } = useLocation();

  // 경로별 타이틀 매핑 (서브타이틀 없음)
  const titleMap = {
    '/about': '회사 소개',
    '/instructors': '강사 소개',
    '/partners': '파트너사',
    '/centers': '협력센터',
  };
  const title = titleMap[pathname] || '회사 소개';

  // 경로별 hero 이미지 우선순위: 섹션 전용 > 공통 > fallback
  const sectionKey =
    pathname === '/instructors' ? 'instructors' :
    pathname === '/partners'    ? 'partners' :
    pathname === '/centers'     ? 'centers'  :
    'about';

  const resolvedHero =
    heroBg ||
    data?.[sectionKey]?.hero ||
    data?.hero?.bg ||
    'https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&w=2070&q=80';

  const resolvedTabs = tabs || data?.tabs || [
    { label: '회사 소개', path: '/about' },
    { label: '강사 소개', path: '/instructors' },
    { label: '파트너사', path: '/partners' },
    { label: '협력센터', path: '/centers' },
  ];

  return (
    <div className="about-page">{/* about.css의 .about-page .container 규칙 적용용 */}
      {/* Hero (공통) */}
      <section
        className="about-hero"
        style={{ backgroundImage: `url('${resolvedHero}')` }}
      >
        <div className="container">
          <h1>{title}</h1>
          {/* 서브타이틀 제거 요청 → 아무 것도 렌더링 안 함 */}
          <div className="hero-underline" />
        </div>
      </section>

      {/* Tabs (공통) */}
      <section className="about-nav">
        <div className="container">
          <NavTabs tabs={resolvedTabs} />
        </div>
      </section>

      {/* 페이지 본문 */}
      <main>{children}</main>
    </div>
  );
}
